import React, { useState } from 'react';
import proptypes from 'prop-types';
const { func, shape, string } = proptypes;
import { extend } from '@thd-nucleus/data-sources';
import {
  Button, Drawer, DrawerHeader
} from '@one-thd/sui-atomic-components';
import { Filters } from '@one-thd/sui-icons';
import { FilterDrawerContent } from './FilterDrawerContent';
import { clearFiltersAnalytics } from '../../helpers';
import {
  PROJECTS_FILTER_DRAWER,
  CARD_VIEW_TYPE,
  ANALYTICS_FILTERS_DRAWER_RESET
} from '../project-summary-helper';

export const FilterDrawer = ({ onApplyFilters, initialFilters = {}, viewType = CARD_VIEW_TYPE }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleOpen = () => {
    setIsOpen(true);
    LIFE_CYCLE_EVENT_BUS.trigger(PROJECTS_FILTER_DRAWER);
  };

  const handleApplyFilters = (filters) => {
    onApplyFilters(filters);
    setIsOpen(false);
  };

  const handleResetFilters = (filters) => {
    // Trigger reset filters analytics
    clearFiltersAnalytics({
      viewType,
      clearType: ANALYTICS_FILTERS_DRAWER_RESET
    });

    // For reset, apply filters but don't close the drawer
    onApplyFilters(filters);
  };

  return (
    <>
      <Button
        startIcon={Filters}
        variant="tertiary"
        onClick={handleOpen}
        data-testid="projects-all-filters-button"
      >
        All Filters
      </Button>
      <Drawer
        open={isOpen}
        onClose={handleClose}
      >
        <DrawerHeader title="Filters" onClose={handleClose} />
        <FilterDrawerContent
          open={isOpen}
          onClose={handleClose}
          onApplyFilters={handleApplyFilters}
          onResetFilters={handleResetFilters}
          initialFilters={initialFilters}
        />
      </Drawer>
    </>
  );
};

FilterDrawer.displayName = 'FilterDrawer';

FilterDrawer.propTypes = {
  onApplyFilters: func.isRequired,
  initialFilters: shape({
    projectName: string,
    projectNumber: string,
    projectStatus: string
  }),
  viewType: string
};

FilterDrawer.defaultProps = {
  initialFilters: {},
  viewType: CARD_VIEW_TYPE
};

FilterDrawer.dataModel = extend(

);
